// extracted by mini-css-extract-plugin
export var deliveryRow = "_ra-a";
export var fixedHeight = "_ra-4";
export var freightLogo = "_ra-9";
export var fullWidth = "_ra-3";
export var priceColumn = "_ra-5";
export var radioSelected = "_ra-7";
export var radioUnselected = "_ra-6";
export var selectedOption = "_ra-2";
export var selectedOptionContainer = "_ra-1";
export var selection = "_ra-0";
export var tallSkeletonText = "_ra-8";